export function onEscape (action: Function): (event: KeyboardEvent) => void {
    return (event) => {
        if (event.key === 'Escape') { action(event) }
    }
}
